import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core'
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar'
import { ItemFacade } from 'libs/gb-front/item/data-access/src/lib/+state/items.facade'
import { PopperPayload } from 'libs/gb-front/item/data-access/src/lib/+state/items.models'
import * as ItemActions from 'libs/gb-front/item/data-access/src/lib/+state/items.actions'

export interface BackgroundStyle {
  'background-image': string
}

@Component({
  selector: 'gb-popper',
  templateUrl: './gb-popper.component.html',
  styleUrls: ['./gb-popper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPopperComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public popperPayload: PopperPayload,
    private itemFacade: ItemFacade,
    public sbRef: MatSnackBarRef<GbPopperComponent>,
  ) {}

  getBackgroundStyle(backgroundImage: string): BackgroundStyle {
    return { 'background-image': `url("${backgroundImage}")` }
  }

  goToItem(): void {
    this.itemFacade.dispatch(ItemActions.navigateToItem({ uuid: this.popperPayload.item_uuid }))
  }

  hidePopper(): void {
    this.sbRef.dismiss()
    this.itemFacade.dispatch(ItemActions.showPoppers({ showPoppers: false }))
  }
}
